import { CEPriceBase } from './ce-price-base'


export class CEPrice extends CEPriceBase {

}